// UserSessionTick.js
import { connect } from 'react-redux';
import UserSessionTick from '../component/UserSessionTick.jsx';

export default connect(null, null)(UserSessionTick);
